module.exports = __webpack_public_path__ + "static/media/stc_logo.f0bbe680.svg";